/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Calendar = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M7.75 1V3H16.25V1H17.75V3H22V23H2V3H6.25V1H7.75ZM20.5 10.25H3.5V21.5H20.5V10.25ZM6.25 4.5H3.5V8.75H20.5V4.5H17.75V7H16.25V4.5H7.75V7H6.25V4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
